import { Record } from 'immutable';
import * as types from './actionTypes';

const requestReducerState = Record({
  data: {},
  fetching: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.TRANSLATION_REQUEST:
    case types.TRANSLATION_UPDATE_REQUEST:
      return state.set('fetching', true).set('data', {});
    case types.SET_TRANSLATION:
    case types.TRANSLATION_SUCCESS:
    case types.TRANSLATION_UPDATE_SUCCESS:
      return state.set('fetching', false).set('data', payload);
    case types.TRANSLATION_FAILURE:
    case types.TRANSLATION_UPDATE_FAILURE:
      return state.set('fetching', false);
    default:
      return state;
  }
};
